import './App.css';

import { Routes, Route } from 'react-router-dom'

import NotFound from './pages/NotFound/NotFound'
import Home from './pages/Home/Home'
import Corperate from './pages/Corperate/Corperate'
import ECatalog from './pages/ECatalog/ECatalog'
import Contact from './pages/Contact/Contact'
import Wirerod from './pages/Wirerod/Wirerod'
import Standardgalvanizedwire from './pages/Standardgalvanizedwire/Standardgalvanizedwire'
import Steelrebar from './pages/Steelrebar/Steelrebar'
import Steelingot from './pages/Steelingot/Steelingot'
import Products from './pages/Products/Products'
import EPIndustrialCooler from './pages/EPIndustrialCooler/EPIndustrialCooler'

import HomeTr from './pages/Turkey/Home/Home'
import CorperateTr from './pages/Turkey/Corperate/Corperate'
import ProductsTr from './pages/Turkey/Products/Products'
import ECatalogTr from './pages/Turkey/ECatalog/ECatalog'
import ContactTr from './pages/Turkey/Contact/Contact'
import WirerodTr from './pages/Turkey/Wirerod/Wirerod'
import StandardgalvanizedwireTr from './pages/Turkey/Standardgalvanizedwire/Standardgalvanizedwire'
import SteelrebarTr from './pages/Turkey/Steelrebar/Steelrebar'
import SteelingotTr from './pages/Turkey/Steelingot/Steelingot'
import EPIndustrialCoolerTr from './pages/Turkey/EPIndustrialCooler/EPIndustrialCooler'

import HomeAr from './pages/Arabic/Home/Home'
import CorperateAr from './pages/Arabic/Corperate/Corperate'
import ProductsAr from './pages/Arabic/Products/Products'
import ECatalogAr from './pages/Arabic/ECatalog/ECatalog'
import ContactAr from './pages/Arabic/Contact/Contact'
import WirerodAr from './pages/Arabic/Wirerod/Wirerod'
import StandardgalvanizedwireAr from './pages/Arabic/Standardgalvanizedwire/Standardgalvanizedwire'
import SteelrebarAr from './pages/Arabic/Steelrebar/Steelrebar'
import SteelingotAr from './pages/Arabic/Steelingot/Steelingot'
import EPIndustrialCoolerAr from './pages/Arabic/EPIndustrialCooler/EPIndustrialCooler'

function App() {
  return (
    <div className="App">
      <Routes>
        <Route path='*' element={<NotFound />} />
        <Route path='/' exact index element={<Home />} />
        <Route path='/corperate' element={<Corperate />} />
        <Route path='/e-catalog' element={<ECatalog />} />
        <Route path='/products' element={<Products />} />
        <Route path='/contact' element={<Contact />} />
        <Route path='/wirerod' element={<Wirerod />} />
        <Route path='/standardgalvanizedwire' element={<Standardgalvanizedwire />} />
        <Route path='/steelrebar' element={<Steelrebar />} />
        <Route path='/steelingot' element={<Steelingot />} />
        <Route path='/EPIndustrialCooler' element={<EPIndustrialCooler />} />

        <Route path='/tr' exact index element={<HomeTr />} />
        <Route path='/tr/corperate' element={<CorperateTr />} />
        <Route path='/tr/products' element={<ProductsTr />} />
        <Route path='/tr/e-catalog' element={<ECatalogTr />} />
        <Route path='/tr/contact' element={<ContactTr />} />
        <Route path='/tr/wirerod' element={<WirerodTr />} />
        <Route path='/tr/standardgalvanizedwire' element={<StandardgalvanizedwireTr />} />
        <Route path='/tr/steelrebar' element={<SteelrebarTr />} />
        <Route path='/tr/steelingot' element={<SteelingotTr />} />
        <Route path='/tr/EPIndustrialCooler' element={<EPIndustrialCoolerTr />} />

        <Route path='/ar' exact index element={<HomeAr />} />
        <Route path='/ar/corperate' element={<CorperateAr />} />
        <Route path='/ar/products' element={<ProductsAr />} />
        <Route path='/ar/e-catalog' element={<ECatalogAr />} />
        <Route path='/ar/contact' element={<ContactAr />} />
        <Route path='/ar/wirerod' element={<WirerodAr />} />
        <Route path='/ar/standardgalvanizedwire' element={<StandardgalvanizedwireAr />} />
        <Route path='/ar/steelrebar' element={<SteelrebarAr />} />
        <Route path='/ar/steelingot' element={<SteelingotAr />} />
        <Route path='/ar/EPIndustrialCooler' element={<EPIndustrialCoolerAr />} />
      </Routes>
    </div>
  );
}

export default App;
